export default __webpack_public_path__ + "static/media/masscopter.ae9e339e.png";